/*
  Importes de envío en la moneda del cliente (process/mercados_envios.md §5).
  El snippet shipping-text marca cada importe como <span class="fs-money" data-eur="4.95" data-kind="rate|free">€4.95</span>.
  Aquí se convierte con el tipo de cambio que publica Shopify en la página (Shopify.currency), el mismo del pago.
  Todos los importes se redondean al alza a la unidad, sin decimales (regla del usuario, 10 oct).
  Sin JavaScript, o en euros, se queda el texto en euros. Lo carga sections/announcement-bar.liquid una vez por página.
*/
(function () {
  if (window.__fsMoney) return;
  window.__fsMoney = true;
  var c = window.Shopify && window.Shopify.currency;
  if (!c || !c.active || c.active === 'EUR') return;
  var rate = parseFloat(c.rate);
  if (!(rate > 0)) return;
  var lang = document.documentElement.lang || 'en';
  var whole;
  try {
    whole = new Intl.NumberFormat(lang, { style: 'currency', currency: c.active, minimumFractionDigits: 0, maximumFractionDigits: 0 });
  } catch (e) { return; }

  function convert(el) {
    var eur = parseFloat(el.getAttribute('data-eur'));
    if (isNaN(eur)) return;
    var v = eur * rate;
    // Regla del usuario (10 oct): todos los importes redondeados al alza a la unidad, sin decimales
    el.textContent = whole.format(Math.ceil(v - 1e-9));
    el.setAttribute('data-done', '1');
  }
  function run(root) {
    if (root.matches && root.matches('.fs-money:not([data-done])')) convert(root);
    if (root.querySelectorAll) root.querySelectorAll('.fs-money:not([data-done])').forEach(convert);
  }
  function start() {
    run(document);
    // El carrito y otras secciones se vuelven a pintar sin recargar la página
    new MutationObserver(function (list) {
      list.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) run(n); }); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
